var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLongArrowBackwardRtl = function SvgLongArrowBackwardRtl(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M72.43 68.572c.573.571 1.5.57 2.073-.001l16.069-16.06.026-.027a1.46 1.46 0 0 0-.027-2.04L74.532 34.429l-.027-.027a1.47 1.47 0 0 0-2.046.026l-.026.028a1.46 1.46 0 0 0 .026 2.04L85.982 50H11.5l-.145.007A1.5 1.5 0 0 0 11.5 53h74.44L72.429 66.504l-.027.027a1.46 1.46 0 0 0 .028 2.041"
  })));
};
export default SvgLongArrowBackwardRtl;